import { usePortalScreen } from '../../../app/telemetry/usePortalTelemetry';
import { portalScreenContext, trackPortalEvent } from '../../../app/telemetry/portalTelemetry';
import { Box, Button, Grid, Paper, Typography } from "@mui/material";
import { AppPathEnum } from "../../../app/enums/appPathEnum";
import { useHistory } from "react-router-dom";

export default function EventSubmission() {
    const history = useHistory();
    usePortalScreen(portalScreenContext('EventSubmission'));

    const redirectToPcsEventDashboard = () => {
        trackPortalEvent(portalScreenContext('EventSubmission'), 'ActionSelected', { action: 'dashboard', direction: 'dashboard' });
        let url = new URLSearchParams(window.location.search);
        url.delete('eventId');
        url.toString();
        history.push(`${AppPathEnum.PCS_EVENT_APPROVAL}?${url.toString()}`);
    }

    return <Box sx={{ width: '100%' }} component={Paper}>

        <Grid container rowSpacing={4} sx={{ margin: "2%" }}>

            <Grid size={{ xs: 12 }}></Grid>

            <Grid size={{ xs: 12 }}>
                <Typography variant='h4'>Application submitted successfully</Typography>
            </Grid>

            <Grid size={{ xs: 12 }}>
                <Typography variant='subtitle1'>
                    You have submitted your CPD Event application successfully.
                </Typography>
            </Grid>

            <Grid size={{ xs: 12 }}>
                <Button variant="contained" onClick={redirectToPcsEventDashboard}>
                    Back to PCS events dashboard
                </Button>
            </Grid>

            <Grid size={{ xs: 12 }}></Grid>
        </Grid>
    </Box>
}